import { xs_languageCode } from "../..";
import { splitHandicap } from "../splitHandicap";

export function getOutcomeSpread(handicap, tipoHandicap, draws, additionalData) {
	const result = splitHandicap(handicap, tipoHandicap, draws, additionalData, xs_languageCode);
	let toAppend = '';
    for (let i = 0; i < result.infoCalcolate; i++) {
        const info = result[`info${i + 1}`] || '';
        if (info.length === 0) {
            continue;
        }
		toAppend += `${(i > 0 && toAppend.length > 0) ? '/': ''}${info}`;
	}
	return toAppend;
}
